// 트랜잭션 목록(txs, home txs, transfers) 헤더용 : 정렬 기준 안내까지 포함한다.
export const TIME_TX_LIST_TOOLTIP =
  "TIME is the transaction signing time. The list is sorted by block number, not by TIME.";

// 트랜잭션 상세용 : 목록이 없으므로 정렬 안내는 제외한다.
export const TIME_TX_DETAIL_TOOLTIP = "TIME is the transaction signing time.";

// 블록 목록/상세용 : 블록의 TIME 은 포함된 트랜잭션에서 파생되는 값이다.
export const TIME_BLOCK_TOOLTIP =
  "A block's TIME reflects the transactions it contains: for a block with multiple transactions, the most recent signing time is shown.";

export const blockTableFields = [
  { id: "block_number", name: "BLOCK NUMBER" },
  { id: "tx_created_time", name: "TIME", tooltip: TIME_BLOCK_TOOLTIP },
  { id: "tx_count", name: "TOTAL TXS" },
  { id: "block_hash", name: "BLOCK HASH" },
  { id: "data_hash", name: "DATA HASH" }
];

export const txTableFields = [
  { id: "tx_id", name: "TX ID" },
  { id: "tx_created_time", name: "TIME", tooltip: TIME_TX_LIST_TOOLTIP },
  { id: "from", name: "FROM" },
  { id: "to", name: "TO" },
  { id: "amount", name: "AMOUNT(PCI)" },
  { id: "type", name: "FUNCTION" },
  { id: "validation_code", name: "VALIDATION CODE" }
];

export const blockTableHomeFields = [
  { id: "block_number", name: "BLOCK NUMBER" },
  { id: "tx_created_time", name: "TIME", tooltip: TIME_BLOCK_TOOLTIP },
  { id: "tx_count", name: "TOTAL TXS" },
  { id: "block_hash", name: "BLOCK HASH" },
  { id: "data_hash", name: "DATA HASH" }
];

export const txTableHomeFields = [
  { id: "tx_id", name: "TX ID" },
  { id: "tx_created_time", name: "TIME", tooltip: TIME_TX_LIST_TOOLTIP },
  { id: "amount", name: "AMOUNT(PCI)" },
  { id: "type", name: "FUNCTION" }
];

export const transferTableFields = [
  { id: "tx_id", name: "TX ID" },
  { id: "from", name: "FROM" },
  { id: "to", name: "TO" },
  { id: "amount", name: "AMOUNT(PCI)" },
  { id: "type", name: "FUNCTION" },
  { id: "tx_created_time", name: "TIME", tooltip: TIME_TX_LIST_TOOLTIP },
];

export const unwrapTableFields = [
  { id: "field", name: "TX Receipt Category" },
  { id: "value", name: "Values" }
];


export const richaccountsTableFields = [
  { id: "id", name: "ID" },
  { id: "address", name: "ADDRESS" },
  { id: "amount", name: "AMOUNT(PCI)"},
  { id: "ratio", name: "RATIO(%)"}

];
export const RecordOptions = [10, 25, 50, 100];



// WEBPACK FOOTER //
// ./src/js/fields.js